import TiktokPixel from 'tiktok-pixel';


// const advancedMatching = {
//   email: 'some@email.com',
//   phone_number: '0123456789',
// }; // optional, more info: https://ads.tiktok.com/help/article?aid=10007891


const options = {
  debug: true, // enable logs
};

class TikTok {
  constructor(email) {
    this.pixel = TiktokPixel;
    // console.log("(process.env.FACEBOOK_PIXEL_ID)", process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID)
    this.pixel.init(
      process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID,
      email ? { email: email } : null, options
    );
  }

  trackPurchase(product, priceId, quantity, value) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('CompletePayment', {
      price: value,
      quantity: quantity,
      value: value * quantity,
      currency: 'USD',
      content_type: "product",
      content_ids: [priceId],
      content_name: product,
      description: product,
    });
  }

  trackInitiateCheckout(product, priceId, quantity, value,) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('InitiateCheckout', {
      price: value,
      quantity: quantity,
      value: value * quantity,
      currency: 'USD',
      content_type: "product",
      content_ids: [priceId],
      content_name: product,
      description: product,
    });
  }


  trackAddPaymentInfo(product, priceId, quantity, value) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('AddPaymentInfo', {
      price: value,
      quantity: quantity,
      value: value * quantity,
      currency: 'USD',
      content_type: "product",
      content_ids: [priceId],
      content_name: product,
      description: product,

    });
  }



  trackCustom(event, data) {
    this.pixel.track(event, data);
  }

}


export default TikTok


